import React from 'react'
import {StyledModal} from 'common/StyledModal'
import styles from './SaveFailureDialog.scss'
import {Button} from 'common/Button'

export const SaveFailureDialog = ({onRequestClose}) => (
  <StyledModal maxWidth={400} onRequestClose={onRequestClose} showModal>
    <div className={styles.SaveFailureDialog}>
      <h2>We're having trouble saving your report.</h2>
      <p>Don't worry - all your changes up to the last minute or so are safe and sound on our servers.</p>
      <p>Please check that your computer is connected to the Internet, and reload the page.</p>
      <p>If you continue to see this message, please <a href='https://ridewithgps.zendesk.com/hc/en-us/requests/new'>contact support</a>.</p>
      <div className={styles.buttons}>
        <a onClick={window.location.reload}><Button className={styles.reloadButton}>Reload</Button></a>
        <Button className={styles.closeButton} type='default' onClick={onRequestClose}>Close</Button>
      </div>
    </div>
  </StyledModal>
)
